import { Component, Ref, log, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import 'country-flag-icons/3x2/flags.css';

@Component
export class ShopLocalization extends ThemeComponent {
    @Ref()
    button!: HTMLButtonElement;
    @Ref()
    panel!: HTMLOListElement;
    @Ref()
    form!: HTMLFormElement;
    @Ref()
    details!: HTMLDetailsElement;

    init() {
        const localOptions = this.panel.querySelectorAll('label');
        for (const option of localOptions) {
            this.$listen(option, 'click', (evt) => this.submitForm());
        }
        this.$listen(this.button, 'focusout', () => {
            setTimeout(() => {
                if (!this.contains(document.activeElement)) { this.details.removeAttribute('open'); }
            });

        });
    }
    submitForm() {
        this.form.submit();
    }
}
